import { render } from "./TablePager.vue?vue&type=template&id=c8b8fa24&scoped=true"
import script from "./TablePager.vue?vue&type=script&lang=js"
export * from "./TablePager.vue?vue&type=script&lang=js"

import "./TablePager.vue?vue&type=style&index=0&id=c8b8fa24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b8fa24"]])

export default __exports__